import { SVGProps, Ref, forwardRef } from 'react';

export const VkSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8.625 12.386c-4.783 0-7.511-3.28-7.625-8.736h2.396c.079 4.005 1.845 5.701 3.244 6.051V3.65h2.256v3.454c1.382-.149 2.833-1.723 3.323-3.454h2.256c-.376 2.134-1.95 3.708-3.07 4.355 1.12.524 2.913 1.897 3.595 4.38h-2.483c-.534-1.66-1.863-2.946-3.62-3.121v3.122z"
                fill="currentColor"
            />
        </g>
    </svg>
));
VkSolidSize16Glyph.displayName = 'VkSolidSize16Glyph';
